/**
 * Krannich-Farbwelt: die Werte selbst.
 *
 * Ausgangspunkt ist das Markengelb #FFCC00 aus dem KI-Logo. Es laesst sich
 * jedoch NICHT als Flaechenfarbe fuer Schaltflaechen verwenden: Weisser Text
 * darauf erreicht 1,5:1 Kontrast, gefordert sind 4,5:1. Schwarzer Text auf
 * Gelb liegt dagegen bei 13,9:1.
 *
 * Die Rampe traegt deshalb zwei Rollen:
 *  * Die dunklen Stufen (10–100) sind ein tiefes Gold. Fluent nutzt Stufe 80
 *    fuer Flaechen mit weissem Text – #996600 erreicht dort 4,9:1.
 *  * Die hellen Stufen (130–160) sind das reine Markengelb und dienen
 *    Akzenten, aktiven Navigationseintraegen und dem Logo.
 *
 * Die Stufenwerte wurden gegen Weiss und gegen den dunklen Fluent-Hintergrund
 * gerechnet, nicht geschaetzt; test/theme.test.ts haelt das fest.
 *
 * Bewusst getrennt von theme.ts: Diese Datei enthaelt nur Werte und einen
 * Typimport, laedt also kein Fluent zur Laufzeit. Dadurch ist sie in Tests und
 * im Logo verwendbar, ohne die gesamte Komponentenbibliothek einzuziehen.
 */
import type { BrandVariants } from '@fluentui/react-components';

/** Markengelb aus dem Krannich-KI-Logo. Einzige Quelle fuer die Rampe. */
export const KRANNICH_YELLOW = '#FFCC00';
/** Zweitfarbe des Logos: reines Schwarz fuer Glyphen und Knoten. */
export const KRANNICH_BLACK = '#000000';

export const krannichBrand: BrandVariants = {
  10: '#1A1100',
  20: '#2B1D00',
  30: '#402B00',
  40: '#543800',
  50: '#6A4700',
  60: '#7D5200',
  70: '#8A5B00',
  // Stufe 80 = Flaechen mit weissem Text (Schaltflaechen, Badges).
  80: '#996600',
  90: '#A66E00',
  100: '#B87A00',
  110: '#CC8800',
  120: '#E09800',
  // Ab hier das Markengelb: Akzente, aktive Zustaende, Logo.
  130: KRANNICH_YELLOW,
  140: '#FFD84D',
  150: '#FFE699',
  160: '#FFF6D6',
};
